import React from 'react';


import profilePic from '../../images/profile-placeholder.jpg';


export default function MessageHeader(props){
    let user = props.user ;
    if(!user){
        return(<></>)
    }
    else{
        return(
            <header  className="row m-0 p-2 align-items-center border-bottom">
                <figure className="mb-0 col-lg-1 col-2 text-center p-0">
                    <img alt="user" src={user?.profile_image?.url || user?.logo?.url || profilePic} height="45px" width="45px" className="rounded-circle"/>
                </figure>
                <article className="col-lg-11 col-10 pl-0">
                        <p style={{fontSize : '16px'}} className=" text-grey mb-0">{user?.name}</p>
                        {/* <p style={{fontSize : '12px'}} className="text-grey mb-0 ">5 min ago</p> */}
                </article>
            </header>
        )
    }
}